import { connect } from 'react-redux';

import { removeError as onClose, connectionOnline, connectionOffline } from './actions';
import ErrorHandlerComponent from './error-handler-component';

function mapStateToProps(state) {
	return {
		error: state.session.errors,
	};
}

export default connect(mapStateToProps, {
	onClose,
	connectionOnline,
	connectionOffline,
})(ErrorHandlerComponent);
